import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { useAuthContext } from 'modules/auth/context';
import { getStudyStreak, logFocusMinutes } from './api';

const streakKey = (userId?: string) => ['study-streak', userId] as const;

export function useStudyStreak() {
  const { state } = useAuthContext();
  return useQuery({
    queryKey: streakKey(state.user?.id),
    queryFn: ({ signal }) => getStudyStreak(signal),
    enabled: Boolean(state.user?.id),
  });
}

/** Logs a focus session, then refreshes the streak (a 10-minute session can start or extend it). */
export function useLogFocus() {
  const { state } = useAuthContext();
  const client = useQueryClient();
  return useMutation({
    mutationFn: (minutes: number) => logFocusMinutes(minutes),
    onSettled: () => client.invalidateQueries({ queryKey: streakKey(state.user?.id) }),
  });
}
